module.exports = __webpack_public_path__ + "c7de8c816fccc2c3aad57f7a8f2bf9de.png";